/** Settings: tabs across the top, each tab its own address so it can be linked. */
import { Link, Outlet, createFileRoute, useRouterState } from '@tanstack/react-router';

export const Route = createFileRoute('/settings')({
  component: Settings,
});

const TABS = [
  { to: '/settings/users', label: 'Users' },
  { to: '/settings/integrations', label: 'Integrations' },
  { to: '/settings/vocab', label: 'Categories and products' },
  { to: '/settings/ai', label: 'AI spending' },
] as const;

function Settings() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="flex h-full flex-col">
      <div className="px-6 pt-4">
        <h1 className="text-title font-medium">Settings</h1>
        <nav aria-label="Settings" className="mt-3 flex gap-1 border-b border-line">
          {TABS.map((t) => {
            const active = path.startsWith(t.to);
            return (
              <Link
                key={t.to}
                to={t.to}
                aria-current={active ? 'page' : undefined}
                className={`-mb-px border-b-2 px-3 py-2 text-body ${active ? 'border-ink text-ink' : 'border-transparent text-ink-2 hover:text-ink'}`}
              >
                {t.label}
              </Link>
            );
          })}
        </nav>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto px-6 py-4">
        <Outlet />
      </div>
    </div>
  );
}
